export const FULL_ERROR_TEST_ID = 'command-palette.ui.modal.modal-dialog';
export const PARTIAL_ERROR_TEST_ID = 'command-palette.ui.modal.modal-dialog';
export const NO_SEARCH_RESULTS_TEST_ID = 'command-palette.ui.modal.modal-dialog';
export const NO_RECENT_RESULTS_TEST_ID = 'no-recent-results';
